import "../UserProfile.scss";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@App/store";
import { useAppDispatch } from "@Src/app/hooks";
import { syncLanguageName } from "@Src/utils/service/language-sync.service";
import PersonalCheckSvg from "@Assets/svg/Myprofile/Profilechecked.svg"
import { EditCoursesIndex } from "../EditCourses";
import { getCouresePreferences, getUserDetails } from "../Services/UserProfile.sevice";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { setCoursePreferences } from "@Src/app/reducers/auth/coursePreferencesSlice";

export const CoursePreferenceIndex = () => {
  const courseprefernces = useSelector((state: RootState) => state.coursePreferences);
  const loginData = useSelector((state: RootState) => state.login);
  const dispatch = useAppDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [userApiData, setUserApiData] = useState<any>(null);

  // Check if course preferences can be updated
  const canUpdateCoursePreferences = () => {
    return true; // client can update board and class always (later it can be implemented)
    /*
    if (!userApiData) return true;
    
    const { CoursePreferanceUpdateDate, Student_sub_StartDate, Institute_sub_StartDate, InstituteId } = userApiData;
    const startDate = InstituteId ? Institute_sub_StartDate : Student_sub_StartDate;
    
    if (!CoursePreferanceUpdateDate || !startDate) return true;
    
    return new Date(CoursePreferanceUpdateDate) < new Date(startDate);
    */
  };

  // Fetch user details from API
  const fetchUserDetails = () => {
    getUserDetails().then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS && response.data?.[0]) {
        setUserApiData(response.data[0]);
      }
    }).catch((error: any) => {
      console.log(error);
    });
  };
  const fetchCoursePref = () => {
    getCouresePreferences().then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS) {

        dispatch(setCoursePreferences(response.data));

      }
    })
  }

  useEffect(() => {
    fetchUserDetails();
    fetchCoursePref();
  }, []);

  // Refresh user data when exiting edit mode
  useEffect(() => {
    if (!isEdit && userApiData) {
      fetchUserDetails();
    }
  }, [isEdit]);

  useEffect(() => {
    if (loginData?.LanguageId && !loginData?.LanguageName) {
      syncLanguageName(loginData.LanguageId, dispatch);
    }
  }, [loginData?.LanguageId, loginData?.LanguageName, dispatch]);

  const subjectdatamap: any = courseprefernces?.subjectDetails
  return (
    <>
      <div className="user-profile-right-container ">
        <div className="user-act-header">

          <div className="usr-prf-heading">Your Study Profile</div>

        </div>
        {isEdit ?
          <EditCoursesIndex setIsEdit={setIsEdit} courseprefernces={courseprefernces} canUpdateCoursePreferences={canUpdateCoursePreferences} /> : <div>


            <div className="user-profile-card personal-detail-card tw-bg-white tw-shadow-lg tw-rounded-2xl">
              <div className="user-profile-card-main-heading tw-flex tw-items-center">Your Academic Setup
                <span className="tw-ml-8">
                  <img src={PersonalCheckSvg} alt="profiel-svg" />
                </span>
              </div>

              <div className="tw-flex tw-mt-5">
                <div className="tw-w-1/2">
                  <div className="user-profile-card-sub-heading">Preferred Language</div>
                  <div className="u-p-c-para-2">
                    {loginData?.LanguageName}
                  </div>
                </div>
                <div className="tw-w-1/2">
                  <div className="user-profile-card-sub-heading">Current Class</div>
                  {courseprefernces?.classDetails && (
                    <div className={`u-p-c-para-2 ${!canUpdateCoursePreferences() ? 'tw-opacity-50' : ''}`}>
                      {courseprefernces?.classDetails[0]?.Name}
                    </div>
                  )}
                </div>
              </div>

              <div className="tw-flex tw-mt-5">
                <div className="tw-w-1/2">
                  <div className="user-profile-card-sub-heading">Education Board</div>
                  {userApiData?.ExactBoardName && (
                    <div className={`u-p-c-para-2 ${!canUpdateCoursePreferences() ? 'tw-opacity-50' : ''}`}>
                      {userApiData.ExactBoardName}
                    </div>
                  )}
                </div>
                <div className="tw-w-1/2">
                  <div className="user-profile-card-sub-heading">Target Exam</div>
                  {courseprefernces?.boardDetails && (
                    <div className={`u-p-c-para-2 ${!canUpdateCoursePreferences() ? 'tw-opacity-50' : ''}`}>
                      {courseprefernces?.boardDetails[0]?.Name}
                    </div>
                  )}
                </div>

              </div>

              <div className="tw-flex tw-mt-5">
                {courseprefernces?.educationInterestDetails && courseprefernces?.educationInterestDetails[0]?.Name && <div className="tw-w-1/2">
                  <div className="user-profile-card-sub-heading">Education Interest</div>
                  <div className="u-p-c-para-2">{courseprefernces?.educationInterestDetails[0]?.Name}</div>
                </div>}
                <div className="tw-w-1/2">
                  <div className="user-profile-card-sub-heading">Subjects You Want to Study</div>
                  <div className="u-p-c-para-2">
                    {subjectdatamap?.map((each: any) => each.Name).join(", ")}
                  </div>
                </div>
              </div>
              <div className="tw-text-center tw-mt-9">
                <button
                  className="ia-btn ia-btn-primary"
                  onClick={() => setIsEdit(true)}
                >
                 Update Profile
                </button>
              </div>
            </div>
          </div>}


      </div>
    </>
  );
};